import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getRootProjectByUser, userProjectSelected, saveUserProjectSelected } from '@/api/system/user'
import { getUnReadCount } from '@/api/messageCenter/message'
import Cookies from 'js-cookie'

const user = {
  state: {
    token: getToken(),
    name: '',
    userId: '',
    projectId: '',
    childId: '',
    childName: '',
    playback: '',
    flicker: '',
    unreadCount: '',
    accountLevel: '',
    eqpNumber: '',
    avatar: '',
    neutral: '',
    roles: [],
    alreadyGetInfo: false,
    permissions: [],
    topicPrefix: ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USER_ID: (state, id) => {
      state.userId = id
    },
    SET_PROJECT_ID: (state, projectId) => {
      state.projectId = projectId
    },
    SET_CHILD_ID: (state, childId) => {
      state.childId = childId
    },
    SET_CHILD_NAME: (state, childName) => {
      state.childName = childName
    },
    SET_PLAYBACK: (state, playback) => {
      state.playback = playback
    },
    SET_FLICKER: (state, flicker) => {
      state.flicker = flicker
    },
    SET_UNREAD_COUNT: (state, unreadCount) => {
      state.unreadCount = unreadCount
    },
    SET_NEUTRAL: (state, neutral) => {
      state.neutral = neutral
    },
    SET_ACCOUNT_LEVEL: (state, accountLevel) => {
      state.accountLevel = accountLevel
    },
    SET_AGENT_LEVEL: (state, agentLevel) => {
      state.agentLevel = agentLevel
    },
    SET_ACCOUNT_TYPE: (state, accountType) => {
      state.accountType = accountType
    },
    SET_EQP_NUMBER: (state, eqpNumber) => {
      state.eqpNumber = eqpNumber
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_GETINFO: (state, alreadyGetInfo) => {
      state.alreadyGetInfo = alreadyGetInfo
    },
    SET_TOPICPREFIX: (state, topicPrefix) => {
      state.topicPrefix = topicPrefix
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const loginName = userInfo.loginName.trim()
      const loginPwd = userInfo.loginPwd
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(loginName, loginPwd, code, uuid)
          .then((res) => {
            sessionStorage.removeItem('rows')
            setToken(res.token)
            commit('SET_TOKEN', res.token)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise(async (resolve, reject) => {
        try {
          const info = await getInfo()
          const user = info.user
          Cookies.set('nickName', user.name)
          const avatar =
            user.headImg == '' || user.headImg == null
              ? require('@/assets/images/avatar.png')
              : process.env.VUE_APP_BASE_URL + '/resources' + user.headImg
          if (info.roles && info.roles.length > 0) {
            // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', info.roles)
            commit('SET_PERMISSIONS', user.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_GETINFO', true)
          commit('SET_NAME', user.loginName)
          commit('SET_USER_ID', user.id)
          commit('SET_TOPICPREFIX', user.topicPrefix)
          commit('SET_AVATAR', avatar)
          commit('SET_PLAYBACK', user.playback)
          // localStorage.setItem('flicker', false)
          commit('SET_FLICKER', false)
          commit('SET_NEUTRAL', user.neutral)
          commit('SET_ACCOUNT_LEVEL', user.accountLevel)
          commit('SET_AGENT_LEVEL', user.agentLevel)
          commit('SET_ACCOUNT_TYPE', user.accountType)
          getUnReadCount().then((res) => {
            commit('SET_UNREAD_COUNT', res.data)
          })
          userProjectSelected().then((res) => {
            // console.log('-----------res', res)
            if (res.data) {
              commit('SET_PROJECT_ID', res.data.rootProjectId)
            } else {
              getRootProjectByUser().then((res1) => {
                // console.log('===========res1', res1)
                let params = {
                  rootProjectId: res1.data ? res1.data[0].id : ''
                }
                saveUserProjectSelected(params).then((res2) => {
                  if (res1.data) {
                    commit('SET_PROJECT_ID', parseInt(res1.data[0].id))
                  } else {
                    commit('SET_PROJECT_ID', '')
                  }
                })
              })
            }
          })
          resolve(info)
        } catch (error) {
          reject(error)
        }
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            commit('SET_PERMISSIONS', [])
            sessionStorage.removeItem('rows')
            removeToken()
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
